import React, {
  ReactElement,
} from 'react';
import { useIntl } from 'react-intl';
import Table, {
  TableBody, TableContainer, TableRow, SocialMediaValueCell,
  SocialMediaTableCells,
} from '@fuww/library/src/Table';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import IntelligencePageLayout from '@fuww/library/src/Layouts/IntelligencePage';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Hero from '../components/Hero';
import Head from '../components/Head';
import twitterPages from '../data/staticPages/i/twitter-fashion-index.json';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import FashionIndexTableHead from '../components/FashionIndex/TableHead';

const TwitterFashionIndexPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'twitter-fashion-index',
    'twitterFashionIndex',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['twitterFashionIndex.title'])}
        description={intl.formatMessage(
          messages['twitterFashionIndex.description'],
        )}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(messages['twitterFashionIndex.description'])
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages['twitterFashionIndex.table.ariaLabel'])}
              >
                <FashionIndexTableHead alignRight />
                <TableBody>
                  {twitterPages.map(({ brand, followers, link }, index) => (
                    <TableRow key={brand}>
                      <SocialMediaTableCells
                        index={index + 1}
                        link={link}
                        value={brand}
                      />
                      <SocialMediaValueCell value={followers} alignRight />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'twitterFashionIndex.source'
              ]),
            }}
            />
          </>
        )}
        breadcrumbs={breadcrumbs}
        subTitle={intl.formatMessage(messages['twitterFashionIndex.subTitle'])}
        title={intl.formatMessage(messages['twitterFashionIndex.title'])}
      />
    </>
  );
};

TwitterFashionIndexPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Twitter Fashion Index"
      />
    )}
  >
    {page}
  </Layout>
);

TwitterFashionIndexPage.getInitialProps = redirectRouteToDomain(
  'twitter-fashion-index',
);

export default TwitterFashionIndexPage;
